module.exports = __webpack_public_path__ + "media/3-12.8dea825b.wav";